<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">
                <gj-country-server-select
                        v-model="filter.countryMarketValue"
                >
                </gj-country-server-select>

                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'asin', text: 'ASIN'},
                       {id: 'msku', text: 'MSKU'},
                       {id: 'sku', text: 'SKU'},
                       {id: 'orderId', text: '卖家订单编号'}
                   ]"
                >
                </gj-select-input>

                <gj-select-date-picker
                        v-model="filter.date"
                        type="daterange"
                        :options="[
                            {id: 'shipmentDate', text: '配送时间'},
                            {id: 'purchaseDate', text: '订购时间'}
                        ]"
                >
                </gj-select-date-picker>


                <template #right>
                    <gj-tool-group
                        help
                        setting :table-name="tableName"
                        :sort-gjtable="$refs.gjTable"
                        :table-columns="columns"
                        :download="$permission('amazonShipment:export')" download-url="/operation/amazonShipment/export"
                        :download-params="globalParams">
                    </gj-tool-group>
                    <view-setting
                            :ref="REF_VIEW_SETTING"
                            save-mode="remote"
                            :use-default="true"
                            :module-name="moduleName"
                            :config="model"
                            :fn-generate-params="generateViewParams"
                            @view-change="handleChangeView"
                            @view-complete="handCompleteView"
                    >
                    </view-setting>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:orderId="{row}">
                    <el-row
                        type="flex"
                        align="middle">
                        <div>
                            <gj-button v-if="$permission('order:view')" type="text" @click="opDetailModal(row)">{{row.orderId}}</gj-button>
                            <span v-if="!$permission('order:view')">{{row.orderId}}</span>
                        </div>
                        <gj-copy-icon v-if="isMeaningful(row.orderId)" :content="row.orderId"/>
                    </el-row>
                </template>

                <template v-slot:asin="{row}">
                    <gj-tooltip :text-line="1" :content="row.productName">
                        {{row.productName | defaultShow}}
                    </gj-tooltip>
                    <el-row>
                        <el-col :span="10">
                            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                            <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                        </el-col>
                        <el-col :span="14">
                            <div class="text-ellipsis-1">{{row.msku | defaultShow}}<gj-copy-icon v-if="isMeaningful(row.msku)" :content="row.msku"/></div>
                        </el-col>
                    </el-row>
                </template>

                <template v-slot:sku="{row}">
                    <gj-tooltip :text-line="1" :content="row.skuName" v-if="row.sku">
                        {{row.skuName | defaultShow}}
                    </gj-tooltip>
                    <el-row type="flex">
                        <RelateProductComponent :data="row" />
                    </el-row>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {isMeaningfulMixin, queryMixin} from "@/minxins";
    import {isMeaningful} from "@/utils/common";
    import {exportAmazonShipment, getAmazonShipmentPage} from "@/api/sale";
    import {convertToDate, convertToDateArr, getShortcutDate, generateViewParams} from "@/utils/date.util";
    import SaleOrderDetail from "../saleOrder/modal/sale-order-detail";
    import { RelateProductComponent }from '@/views/components/relate-product/index'
    import model from "./viewConfig";

    export default {
        name: "app-amazonShipment",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {
            RelateProductComponent
        },
        data() {
            return {
                tableName: 'amazonShipment',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    // {marketName: 'aa', asin: 'asin1'}
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', default: true, disabled: true},
                    {id: 'orderId', header: '订单编号', field: 'slot:orderId', minWidth: '160px', default: true},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
                    {id: 'msku', header: '商品标题/ASIN/MSKU', field: 'slot:asin', minWidth: '300px', default: true},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', default: true},
                    {id: 'purchaseMarketDate', header: '订购时间', field: 'purchaseMarketDate', sortable: true, minWidth: '155px', help: '市场时间', default: true},
                    {id: 'paymentsMarketDate', header: '付款时间', field: 'paymentsMarketDate', sortable: true, minWidth: '155px', help: '市场时间', default: true},
                    {id: 'itemPrice', header: '商品售价', field: 'itemPrice', minWidth: '90px', prefix: 'currencySymbol', align: 'right', default: true},
                    {id: 'quantityShipped', header: '发货数量', field: 'quantityShipped', sortable: true, minWidth: '90px', align: 'right', default: true},
                    {id: 'shipmentMarketDate', header: '发货时间', field: 'shipmentMarketDate', sortable: true, minWidth: '155px', help: '市场时间', default: true},
                    {id: 'carrier', header: '承运人', field: 'carrier', minWidth: '110px', default: true},
                    {id: 'trackingNumber', header: '追踪号码', field: 'trackingNumber', minWidth: '120px', default: true},
                    {id: 'estimatedArrivalMarketDate', header: '预计到达时间', field: 'estimatedArrivalMarketDate', sortable: true, minWidth: '155px', help: '市场时间', default: true},
                    {id: 'fulfillmentCenterId', header: '亚马逊仓库代码', field: 'fulfillmentCenterId', minWidth: '110px', default: true},
                    {id: 'buyerName', header: '买家姓名', field: 'buyerName', minWidth: '120px', default: true},
                    {id: 'buyerEmail', header: '买家邮箱', field: 'buyerEmail', minWidth: '150px', overflowLine: 2, default: true},
                    {id: 'buyerPhoneNumber', header: '买家电话', field: 'buyerPhoneNumber', minWidth: '100px', default: true},
                    {id: 'recipientName', header: '收件人姓名', field: 'recipientName', minWidth: '120px', default: true}
                ],
                tableData: [],
                filter: {
                    countryMarketValue: null,
                    keyword: {
                        key: 'asin', value: null,
                    },
                    date: {
                        key: 'shipmentDate', value: null,
                    },
                },
                treeData: [{
                    id: 0, label: '00'
                }],
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                moduleName: 'AMAZON_SHIPMENT',
                model,
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            generateViewParams,
            loadViewComplete () {
                this.$emit('query')
            },
            $gjQueryInitParams() {
                return {
                    filter: {
                        countryMarketValue: null,
                        keyword: {
                            key: 'asin', value: null,
                        },
                        date: {
                            key: 'shipmentDate', value: null,
                        },
                    }
                };
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{countryMarketValue: *}}
             */
            $gjCacheCallback(params) {
                return {
                    countryMarketValue: params.countryMarketValue
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {},
                    ...this.queryPagination,
                    ...this.querySort
                };
                // 关键词查询
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                // 店铺国家
                if (this.filter.countryMarketValue) {
                    params.model.countrys = this.filter.countryMarketValue.countryIds;
                    params.model.marketIds = this.filter.countryMarketValue.marketIds;
                }
                // 时间
                if (isMeaningful(this.filter.date.value)) {
                    if (this.filter.date.key === 'shipmentDate') {
                        params.model.startShipmentMarketTime = convertToDate(this.filter.date.value[0]);
                        params.model.endShipmentMarketTime = convertToDate(this.filter.date.value[1]);
                    } else if (this.filter.date.key === 'purchaseDate') {
                        params.model.startPurchaseMarketTime = convertToDate(this.filter.date.value[0]);
                        params.model.endPurchaseMarketTime = convertToDate(this.filter.date.value[1]);
                    }
                }
                this.globalParams = params;
                // 查询
                this.loading = true;
                getAmazonShipmentPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportAmazonShipment(this.globalParams);
            },
            opDetailModal(row) {
                this.$gjCreate(SaleOrderDetail, {
                    props: {
                        marketId: row.marketId,
                        orderId: row.orderId,
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
